import {Store} from '../classes/store';
import {Injectable} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';
import {BasicArea} from '../../../resources/basic-area/basic-area.interface';

@Injectable({
  providedIn: 'root'
})
export class BasicAreaStore extends Store<BasicArea> {

  /** Constructor. */
  constructor( ) {
    super();
  }

}
